<template>
    <div>
       <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="类别">
            <el-select v-model="form.type" placeholder="请选择分类">
              <el-option
                v-for="item in typelist"
                :key="item.id"
                :label="item.typename"
                :value="item.id">
              </el-option>
            </el-select>
         </el-form-item>
          <el-form-item label="内容">
            <vue-ueditor-wrap v-model="form.content" :config="uEditConfig"></vue-ueditor-wrap>
          </el-form-item>
          <el-form-item label="封面图">
              <el-upload
                :action="uploadImgUrl"
                name='image'
                :data="{extra:'headimg',type:'indeximg'}"
                list-type="picture-card"
                :limit='1'
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success='handleUploadOK'
                :on-exceed='handleExceed'
                :file-list="filelist['headimg']"	
                >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSave">立即保存</el-button>
            <el-button @click='goBack'>取消</el-button>
          </el-form-item>
        </el-form>
    </div>  
</template>
<script>
  import VueUeditorWrap from 'vue-ueditor-wrap' 
  export default {
    components: {
          VueUeditorWrap
    },
    data() {
      const uEditorUrl=process.env.VUE_APP_UEDITOR_SERVERURL+'?token='+this.$store.state.user.token
      return {
        form: {
          id:'',
          title: '',
          type: '',
          content:'',
          headimg:[]
        },
        uploadImgUrl:process.env.VUE_APP_API+"/upload/uploadImg",
        dialogImageUrl: '',
        dialogVisible: false,
        processing:false,
        filelist:[],

        typelist:[],
        uEditConfig: {
                  initialFrameHeight: 240,
                  initialFrameWidth: '100%',
                  serverUrl: uEditorUrl,
                  UEDITOR_HOME_URL: './plugins/UEditor/'
        }
      }
    },
    created(){
          this.form.id=this.$route.query.contentid==undefined?0:this.$route.query.contentid
          this.initContent(this.form.id)
    },
    methods: {
      onSave() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.title==''){
            this.$message.error("内容标题不能为空");return false
          }
          if(this.form.type==''){
            this.$message.error("请选择内容类型");return false
          }
          if(this.form.content==''){
            this.$message.error("内容不能为空");return false
          }
          if(this.form.headimg!=null && this.form.headimg.length>=1){
            this.form.headimg=this.form.headimg[0]
          }
  
          this.processing=true
          this.$post("/content/saveContent",{contentinfo:this.form}).then((data)=>{
               if(data.result.success){
                   this.$message({message:data.result.info,type:'success'})
                   setTimeout(()=>{this.$router.push('/contentlist')},500)
               }else{
                   this.$message.error(data.result.info)
               }
               this.processing=false
          })
      },
      initContent(id){
          this.$post("/content/initContent",{id:id}).then((data)=>{
              if(this.form.id>0){
                 this.form=data.result.info.contentinfo
              }
              this.filelist=data.result.info.filelist
              this.typelist=data.result.info.typelist
          })
      },
      goBack(){
          this.$go("/contentlist")
      },
      handleRemove(file, fileList) {
        let type=file.response.result.info.extra
        switch(type){
          case 'headimg':
                this.form.headimg=this.getSlides(fileList);break;
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;  
          default:
                this.$message("图片类型错误");      
        }
      },
      handleUploadOK(response, file, fileList){
        let type=response.result.info.extra
        switch(type){
          case 'headimg':  
                this.form.headimg=this.getSlides(fileList);break;    
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;
          default:
                this.$message("图片类型错误");      
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getSlides(fileList){
         return fileList.map((item)=>item.response.result.info.url)
      },
      handleExceed(){
         this.$message.error("超出最大上传数量");
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
